import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { QueryParamsHandling } from '@angular/router';

@Component({
  selector: 'aas-formatted-value',
  styleUrls: ['./formatted-value.component.scss'],
  templateUrl: './formatted-value.component.html'
})
export class FormattedValueComponent implements OnInit, OnChanges {

  @Input() id: string; //REQUIRED: must be unique to the page
  @Input() label: string = "";
  @Input() value: any;
  @Input() useLargeFontStyle: boolean = false;
  @Input() emptyMsg: string = "Not Reported";
  @Input() shouldHideOverflow: boolean = true;
  @Input() isCurrency: boolean = false;
  @Input() isDate: boolean = false;
  @Input() isTime: boolean = false;
  @Input() isNumber: boolean = false;
  @Input() isPhone: boolean = false;
  @Input() isPercent: boolean = false;
  @Input() isBoolean: boolean = false;
  @Input() isServerError: boolean = false;
  @Input() hasNgContent: boolean = false;
  @Input() isHyperlink: boolean = false;
  @Input() hyperlinkNewTab: boolean = false;
  @Input() route: string = "";
  @Input() queryParams: any = "";

  public queryParameters: QueryParamsHandling;

  public shouldPipeValue: boolean = false;
  public tooltipValue: string;
  public valueId: string;

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {

    this.shouldPipeValue = (this.isCurrency || this.isDate || this.isNumber || this.isPhone || this.isHyperlink || this.isPercent);

    if(this.isBoolean) {
      this.value = (this.value === "true" ? "Yes" : "No");
    }

    this.tooltipValue = this.value;

    if(this.id && this.id !== "") {
      this.valueId = `${this.id}-value`;
    }
    else {
      this.id = this.label.replace(/\s/g, "").toLowerCase();
      this.valueId = `${this.label.replace(/\s/g, "").toLowerCase()}-value`;
    }

    if(this.isDate)
      this.value = Date.parse(this.value?.toString()) === Date.parse("0001-01-01T00:00:00") ? null : this.value;
  }

  ngOnChanges(): void {
    this.cdr.detectChanges();
  }

  public shouldDisableTooltip(el): boolean {    
    return el.scrollWidth <= el.clientWidth;
  }

}